import 'babel-polyfill';
import {ONE_ELEMENT} from 'util/constants';
import {getNow} from 'util/utils';

const MAX_SHOW_NOTIFICATIONS_ALERTS = 3;

const PENDING_CREDENTIAL = 'PENDING_CREDENTIAL';

export const TYPE_NOTIFICATION_CARD = {
    PENDING_CREDENTIAL
};

export const NOTIFICATION_TYPE = {
    ERROR:   'error',
    WARNING: 'warning',
    SUCCESS: 'success',
    INFO:    'info'
};
const INIT_ID = 0;

/* eslint-disable func-style */
export const getNotificationId = function *getNotificationId(notifications) {
/* eslint-enable func-style */
    let id = notifications ?
        notifications.reduce((ret, item) => item.id > ret ? item.id : ret, INIT_ID) :
        INIT_ID;

    do {
        yield ++id;
    } while (id);
};
let _getNotificationId = null;
/*eslint-disable */
const _createNotification = (notifications, title, text, type, translatable, component, extraData) => {
    if (!_getNotificationId) {
        _getNotificationId = module.exports.getNotificationId(notifications);
    }

    return {
        id:       _getNotificationId.next().value,
        datetime: getNow(),
        read:     false,
        title, text, type, translatable, component, extraData
    };
};
/*eslint-enable */

const _getDefaultState = () => ({
    notifications: [],
    alerts:        []
});

const ADD_NOTIFICATION = 'ADD_NOTIFICATION';

/*eslint-disable */
export const addNotification = (title, text, notificationType, onlyAlert = false, translatable = false, component, extraData) => ({
    type: ADD_NOTIFICATION,
    title, text, notificationType, onlyAlert, translatable, component, extraData
});
/*eslint-enable */
const _addNotification = (state, {title, text, notificationType, onlyAlert, translatable, component, extraData}) => {
    let {notifications} = state;
    const alerts = state.alerts.slice();
    const notification = _createNotification(notifications, title, text, notificationType, translatable, component, extraData);

    if (!onlyAlert) {
        notifications = notifications.slice();
        notifications.unshift(notification);
    }
    alerts.unshift(notification);
    while (alerts.length > MAX_SHOW_NOTIFICATIONS_ALERTS) {
        alerts.pop();
    }

    return { notifications, alerts };
};
const HIDE_NOTIFICATION_ALERT = 'HIDE_NOTIFICATION_ALERT';

export const hideNotificationAlert = id => ({
    type: HIDE_NOTIFICATION_ALERT,
    id
});
const _hideNotificationAlert = (state, {id}) => {
    const alerts = state.alerts.slice();
    const index = alerts.findIndex(notification => notification.id === id);

    alerts.splice(index, ONE_ELEMENT);

    return {
        ...state,
        alerts
    };
};

const REMOVE_NOTIFICATION_ALERT = 'REMOVE_NOTIFICATION_ALERT';

export const removeNotificationAlert = id => ({
    type: REMOVE_NOTIFICATION_ALERT,
    id
});
const _removeNotificationAlert = (state, {id}) => {
    const notifications = state.notifications.slice();
    const alerts = state.alerts.slice();
    const indexN = notifications.findIndex(notification => notification.id === id);
    const indexA = alerts.findIndex(notification => notification.id === id);

    notifications.splice(indexN, ONE_ELEMENT);
    alerts.splice(indexA, ONE_ELEMENT);

    return { notifications, alerts };
};

const REMOVE_ALL_NOTIFICATIONS_ALERT = 'REMOVE_ALL_NOTIFICATIONS_ALERT';

export const removeAllNotificationsAlert = () => ({
    type: REMOVE_ALL_NOTIFICATIONS_ALERT
});
const _removeAllNotificationsAlert = _getDefaultState;

const READ_ALL_NOTIFICATIONS_ALERT = 'READ_ALL_NOTIFICATIONS_ALERT';

export const readAllNotificationsAlert = () => ({
    type: READ_ALL_NOTIFICATIONS_ALERT
});
const _readAllNotificationsAlert = state => ({
    ...state,
    notifications: state.notifications.map(item => ({
        ...item,
        read: true
    }))
});

export const reducer = (state = _getDefaultState(), action = {}) => {
    switch (action.type) {
    case ADD_NOTIFICATION:
        return _addNotification(state, action);
    case HIDE_NOTIFICATION_ALERT:
        return _hideNotificationAlert(state, action);
    case REMOVE_NOTIFICATION_ALERT:
        return _removeNotificationAlert(state, action);
    case REMOVE_ALL_NOTIFICATIONS_ALERT:
        return _removeAllNotificationsAlert();
    case READ_ALL_NOTIFICATIONS_ALERT:
        return _readAllNotificationsAlert(state);
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/notifications.js